module.exports = __webpack_public_path__ + "static/Twitch-Wordmark-White-6e9bbab9fa8baad729fb2fbeaceb2bef.png";